import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const UserContext = createContext();

const UserState = (props) => {
  const [users, setusers] = useState([]);
  const [friends, setfriends] = useState([]);
  const [friendRequests, setfriendRequests] = useState([]);
  const [userDetails, setuserDetails] = useState({
    name: "",
    mNumber: "",
    email: "",
    owes: [],
    gets: [],
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");
  let userId = null;

  if (token) {
    const decoded = jwtDecode(token);
    userId = decoded.user.id; // ✅ user id
  }

  const getUserProfile = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/profile/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const result = await response.json();
      setuserDetails(result);

      return result;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadProfile = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      await getUserProfile();
      setLoading(false);
    };

    loadProfile();
  }, []);

  const getUserDetails = async (id) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/userDetails/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();
    return result;
  };

  const getUsers = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    const result = await response.json();

    setusers(result);
    return result;
  };

  const getFriends = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/friends`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    setfriends(result.friends);
    setfriendRequests(result.requests);
  };

  const sendRequest = async (friendId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/friend-request/${friendId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    await getUsers();
  };

  const acceptRequest = async (friendId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/friend-request/accept/${friendId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    await getFriends();
    await getUsers();
  };

  const deleteRequest = async (friendId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/friend-request/reject/${friendId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    await getFriends();
    await getUsers();
  };

  const unFriend = async (friendId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/users/friend-unfollow/${friendId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    await getFriends();
    await getUsers();
  };

  return (
    <UserContext.Provider
      value={{
        users,
        getUsers,
        sendRequest,
        acceptRequest,
        deleteRequest,
        getFriends,
        getUserProfile,
        userDetails,
        setuserDetails,
        friends,
        friendRequests,
        unFriend,
        getUserDetails,
        loading,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserState };
